import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
//import Mgr from "./service/AuthenticationService";
import axios from 'axios';
import EventBus from './utils/EventBus';

const utils = require('./utils/formatting.js');

// Import Bootstrap an BootstrapVue CSS files (order is important)
import './scss/style.scss';

//import Donut from 'vue-css-donut-chart';
//import 'vue-css-donut-chart/dist/vcdonut.css';
//Vue.use(Donut);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

//Vue.prototype.$securityManager = new Mgr();
Vue.prototype.$axios = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.console = console;
Vue.prototype.window = window;

import { Auth0Plugin } from './auth';

Vue.use(Auth0Plugin, {
  domain: 'dev-tbfxeymi.eu.auth0.com',
  clientId: '5h6zAA7xz2JviuuRqO69E1p3h2DaQoo1',
  audience: 'https://192.168.178.122:8081/api',
  redirect_uri: window.location.origin,
  authorizationParams: {
    redirect_uri: window.location.origin
  },
  onRedirectCallback: appState => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  }
});

Vue.config.productionTip = false;

var lightSchemeIcon = document.querySelector('link#light-scheme-icon');
var darkSchemeIcon = document.querySelector('link#dark-scheme-icon');
var matcher = window.matchMedia('(prefers-color-scheme: dark)');

matcher.addListener(onUpdate);
onUpdate();

function onUpdate() {
  if (matcher.matches) {
    lightSchemeIcon.remove();
    document.head.append(darkSchemeIcon);
  } else {
    document.head.append(lightSchemeIcon);
    darkSchemeIcon.remove();
  }
}

Vue.prototype.$showError = (context, error, title = 'Fehler') => {
  console.log('DISPLAYED ERROR:', error);
  context.$bvToast.toast(error, {
    title,
    variant: 'danger',
    solid: true,
    toaster: 'b-toaster-bottom-right'
  });
};
Vue.prototype.$showWarning = (context, warning, title = 'Warnung') => {
  console.warn('DISPLAYED WARNING:', warning);
  context.$bvToast.toast(warning, {
    title: title,
    variant: 'warning',
    solid: true,
    toaster: 'b-toaster-bottom-right'
  });
};
Vue.prototype.$showSuccess = (context, title, info, toaster = 'b-toaster-bottom-right') => {
  context.$bvToast.toast(info, {
    title: title,
    variant: 'success',
    solid: true,
    toaster
  });
};
Vue.prototype.$handleError = err => {
  if (err.response) this.$showError(this, err.response.data);
  else this.$showError(this, err.toString());
};

Vue.prototype.sortTableItemsBy = (items, field, direction = 'asc', type = null) => {
  //console.log('sorting field', field, ' order ', direction, type);
  items.sort((a, b) => {
    if (type == 'number') {
      a = parseFloat(a[field]);
      b = parseFloat(b[field]);
      if (direction == 'asc') {
        return b - a;
      } else {
        return a - b;
      }
    } else {
      if (a[field] == null) return 1;
      if (b[field] == null) return -1;
      if (direction == 'asc') {
        return a[field].toLowerCase().localeCompare(b[field].toLowerCase());
      } else {
        return b[field].toLowerCase().localeCompare(a[field].toLowerCase());
      }
    }
  });
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
